let vuetifyInstance = null;

export function bindColorScheme(instance) {
    vuetifyInstance = instance || null;
}

function setVuetifyTheme(isDark) {
    if (!vuetifyInstance?.theme?.global) return;
    const name = isDark ? 'dark' : 'light';
    const current = vuetifyInstance.theme.global.name;
    if (current && typeof current === 'object' && 'value' in current) {
        current.value = name;
        return;
    }
    vuetifyInstance.theme.global.name = name;
}

export function applyColorScheme(isDark) {
    const dark = Boolean(isDark);
    if (typeof document !== 'undefined') {
        document.body.classList.toggle('dark', dark);
    }
    setVuetifyTheme(dark);
}

export function readStoredDark() {
    if (typeof localStorage === 'undefined') return false;
    try {
        const saved = localStorage.getItem('weeduc_dark_mode');
        return saved ? Boolean(JSON.parse(saved)) : false;
    } catch (e) {
        return false;
    }
}

export default {
    bindColorScheme,
    applyColorScheme,
    readStoredDark,
};
